<script>
import FINAL from '@/components/final/Index';

export default FINAL;
</script>
